import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import TapIcon from '../../../services/TapIcon';
import AdditionalAttributeForm from '../../includes/ui/AdditionalAttributeForm';
import HttpAPICall from '../../../services/HttpAPICall';
import { HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';

const EmployeeAdditionalAttributesModal = forwardRef((props, ref) => {

    const access_token = useSelector(state => state.auth.access_token);

    const editUrl = HRM_API_BASE_URL_2 + '/employee/addition_attr_edit';

    const modalElem = useRef(null);
    const searchModal = useRef(null);
    const modalID = uuid();
    const [editData, setEditData] = useState({});
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [additionalAttributes, setAdditionalAttributes] = useState([]);
    const [employeeId, setEmployeeId] = useState(null);

    useEffect(() => {
        modalElem.current = document.getElementById(modalID);
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);

    useImperativeHandle(ref, () => ({
        initAdditionalModalHandler: (additionalAttrData, empId) => {
            setEmployeeId(empId);
            setAdditionalAttributes(additionalAttrData || []);
            openModalHandle(additionalAttrData);
        }
    }));

    const searchModalOpen = () => searchModal.current && searchModal.current.show();
    const editadditionalattributesModalClose = () => {
        searchModal.current && searchModal.current.hide()
    };

    const openModalHandle = (additionalAttrData) => {
        searchModalOpen();
        initialDataHandler(additionalAttrData)
    }

    const initialDataHandler = (additionalAttrData) => {
        let updateFormState = [];
        if (additionalAttrData && additionalAttrData.length > 0) {
            additionalAttrData.map((i, k) => {
                let name = "additional_attributes_" + i.key;
                updateFormState[name] = i.value;
            });
        }
        setEditData({
            ...updateFormState
        });
    }

    const submitHandler = (e) => {
        e.preventDefault();

        const form = { ...editData };
        let additional_attributes = {};
        
        additionalAttributes.forEach(attr => {
            const key = attr.key;
            const fieldName = "additional_attributes_" + key;
            additional_attributes[key] = form[fieldName] || "";
            delete form[fieldName];
        });
        
        const payload = {
            id: employeeId,
            additional_attributes
        };
        
        if (employeeId) {
            setFormSubmitting(true)
            HttpAPICall.withAthorization('PUT', editUrl, access_token, null, payload, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                editadditionalattributesModalClose();
                if (props.viewEmployeeDetail) {
                    props.viewEmployeeDetail(employeeId, true);
                }
            })
                .finally(() => setFormSubmitting(false));
        } else {
            toast.error('Something went wrong. You cannot edit the employee.')
        }
    }
    
    return <>
        <div className="modal fade" id={modalID} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="EmployeeAdditionalAttributesModalLabel">Update Additional Attributes</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={editadditionalattributesModalClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form id="editProject" onSubmit={submitHandler} className="bg-white p-3">
                            <div className='ps1'>
                                {additionalAttributes &&
                                    additionalAttributes.length > 0 && (
                                        <AdditionalAttributeForm
                                            additionalAttributes={additionalAttributes}
                                            formState={editData}
                                            onAttributeChange={(value, attributeName) => {
                                                setEditData({
                                                    ...editData,
                                                    [attributeName]: value,
                                                })
                                            }}
                                            colSpan={"col-sm-7"}
                                        />
                                    )}
                            </div>

                            <div className="d-flex align-items-center gap-2 justify-content-end me-5 mt-5 pe-5">
                                <button onClick={editadditionalattributesModalClose} type="button" className="btn btn-secondary">
                                    Close </button>
                                <button type="submit" form='editProject' className="btn btn-primary" disabled={formSubmitting} >Save {formSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>
});
export default EmployeeAdditionalAttributesModal;